export function pxToNumber(px: string): number {
  return Number(px.replace("px", ""));
}
